/* import __COLOCATED_TEMPLATE__ from './auth-app-only.hbs'; */
import TwoFactorEnrollAuthAppComponent from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/enroll/auth-app';
export default class TwoFactorEnrollAuthAppOnlyComponent extends TwoFactorEnrollAuthAppComponent {
  constructor() {
    super(...arguments);
  }
}